'use client';

import type { MarketplaceBalance, RetailerBalanceResult } from '@svenskaspelab/poolbetting/schema/marketplace';
import { type PropsWithChildren, type ReactNode, useContext, useEffect, useRef } from 'react';

import { walletCachedContext } from '@/components/index.browser';

type PixWalletContainerClientProps = PropsWithChildren & {
  wallet?: MarketplaceBalance | RetailerBalanceResult;
};

/**
 * Sets the wallet cache context with marketplace balance data.
 *
 * @param root0 props
 * @param root0.children children to be wrapped with wallet context
 * @param root0.wallet marketplace balance fetched server-side
 * @returns children wrapped with wallet context
 */
export function PixWalletContainerClient({ children, wallet }: PixWalletContainerClientProps): ReactNode {
  const { context } = walletCachedContext;
  const walletContext = useContext(context);
  const hasInitialWalletSet = useRef(false);

  useEffect(() => {
    if (walletContext?.setState && wallet && !hasInitialWalletSet.current) {
      walletContext.setState(wallet);
      hasInitialWalletSet.current = true;
    }
  }, [wallet, walletContext]);

  return <div>{children}</div>;
}
